// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Form, Col, Row, Table } from "react-bootstrap";
// import { IoMdClose } from "react-icons/io";
// import { useNavigate, useParams } from "react-router-dom";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { BASE_URL } from "../../../../services/Api";
// import { authHeader } from "../../../../services/auth-header";

// const ViewAraiMfgSalesEnquiry = ({ enquiryData }) => {
//   const navigate = useNavigate();
//   const { id, pointindex } = useParams();
//   const [customerOptions, setCustomerOptions] = useState([]);
//   const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
//   const [productOptions, setProductOptions] = useState([]);
//   const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
//   const [productData, setProductData] = useState([]);
//   const [customerDetailsOptions, setCustomerDetailsOptions] = useState();
//   const [customerNameValue, setCustomerNameValue] = useState({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
//   const [customerAddressValue, setCustomerAddressValue] = useState({ value: enquiryData?.customeraddress?.id, label: enquiryData?.customeraddress?.customeraddress });

//   const [enquiryDetails, setEnquiryDetails] = useState({
//     enquirytype: "Manufacturing",
//     enquirycategory: "International",
//     enquirydate: "",
//     customer: "",
//     contactperson: "",
//     contactno: "",
//     email: "",
//     customeraddress: "",
//     customermaterialcode: "",
//     enquiryItems: [],
//   });

//   console.log(enquiryData);

//   const manufacturedByOptions = [
//     {
//       value: "Sanisure",
//       label: "Sanisure",
//     },
//     {
//       value: "TBL",
//       label: "TBL",
//     },
//   ];

//   useEffect(() => {
//     const ans = enquiryData?.enquiryItems?.map((data) => ({
//       product: { id: data?.product?.id },
//       description: data?.product?.description,
//       productremarks: data?.productremarks,
//       hsnsacno: data?.hsnsacno,
//       serialnumber: data?.serialnumber,
//       modelnumber: data?.modelnumber,
//       partno: data?.partno,
//       tagnumber: data?.tagnumber,
//       moc: data?.moc,
//       partno: data?.partno,
//       uom: data?.uom,
//       currency: data?.currency,
//       quantity: data?.quantity,
//     }));

//     setEnquiryDetails((prevState) => ({
//       ...prevState,
//       enquirydate: enquiryData?.enquirydate,
//       customer: { id: enquiryData?.customer?.id },
//       contactperson: enquiryData?.contactperson,
//       contactno: enquiryData?.contactno,
//       email: enquiryData?.email,
//       customeraddress: {
//         id: enquiryData?.customeraddress?.id,
//       },
//       status: enquiryData?.status,
//       customermaterialcode: enquiryData?.customermaterialcode,
//       enquiryItems: ans,
//       enquiryno: enquiryData?.enquiryno,
//       enquirycurrency: enquiryData?.enquirycurrency,
//     }));

//     getCustomerAddress(enquiryData?.customer?.id, "I am calling");
//   }, []);

//   async function getCustomerData() {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });
//       setCustomerOptions(
//         response.data.Index
//           ? response.data.Index.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//           : response.data.data.map((customer) => ({
//             value: customer.id,
//             label: customer.companyname,
//           }))
//       );
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getProductData() {
//     try {
//       const response = await axios.get(`${BASE_URL}product/page/pump/0/5/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
//         headers: authHeader(),
//       });

//       console.log(response);

//       setProductOptions(
//         response.data.Index
//           ? response.data.Index.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//           : response.data.data.map((product) => ({
//             value: product.id,
//             label: product.description,
//           }))
//       );

//       setProductData(response.data.Index ? response.data.Index : response.data.data);
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerDetails(id) {
//     try {
//       const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
//         headers: authHeader(),
//       });
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customer: {
//           id: id,
//         },
//         contactperson: response.data.contactperson,
//         contactno: response.data.contactno,
//         email: response.data.email,
//         customeraddress: response.data.address,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   async function getCustomerAddress(id) {
//     if (id) {
//       try {
//         const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
//           headers: authHeader(),
//         });

//         console.log(response);
//         setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   }

//   function handleProductChange(event) {
//     console.log(event.value);

//     const productValue = productData.filter((data) => data.id === event.value);
//     console.log(productValue);

//     let product = {
//       product: {
//         id: productValue[0].id,
//       },
//       description: productValue[0].description,
//       hsnsacno: productValue[0].hsnsacno,
//       serialnumber: productValue[0].serialnumber,
//       modelnumber: productValue[0].modelnumber,
//       tagnumber: productValue[0].tagnumber,
//       moc: productValue[0].moc,
//       partno: productValue[0].partno,
//       uom: productValue[0].unitofmeasurement,
//       quantity: "",
//     };

//     setEnquiryDetails({
//       ...enquiryDetails,
//       enquiryItems: [...enquiryDetails.enquiryItems, product],
//     });
//   }

//   async function handleSubmit(event) {
//     event.preventDefault();

//     try {
//       const response = await axios.put(`${BASE_URL}enquiry/update/${id}`, enquiryDetails, {
//         headers: authHeader(),
//       });

//       Swal.fire({
//         icon: "success",
//         title: "Success",
//         text: "Enquiry updated successfully!",
//       });

//       navigate("/salesEnquiryIndex/1");
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   const handleFormChange = (event, element) => {
//     if (element === "manufacturedby") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         manufacturedby: event.value,
//       });
//       return;
//     }

//     if (element === "customer") {
//       getCustomerDetails(event.value);
//       getCustomerAddress(event.value);
//       setCustomerNameValue(event);
//       setCustomerAddressValue("");
//       return;
//     }

//     if (element === "customeraddress") {
//       setEnquiryDetails({
//         ...enquiryDetails,
//         customeraddress: {
//           id: event.value,
//         },
//       });

//       setCustomerAddressValue(event);
//       return;
//     }

//     const { name, value } = event.target;
//     setEnquiryDetails({
//       ...enquiryDetails,
//       [name]: value,
//     });
//   };

//   const handleQuantityChange = (event, index) => {
//     let rows = enquiryDetails.enquiryItems;

//     rows[index].quantity = event.target.value;

//     setEnquiryDetails({
//       ...enquiryDetails,
//       enquiryItems: rows,
//     });
//   };

//   const removeRow = (idx) => {
//     const arr = enquiryDetails.enquiryItems.filter((item, index) => index !== idx);
//     setEnquiryDetails({
//       ...enquiryDetails,
//       enquiryItems: arr,
//     });
//   };

//   useEffect(() => {
//     getCustomerData();
//     getProductData();
//   }, []);

//   useEffect(() => {
//     getCustomerData();
//   }, [customerSearch]);

//   useEffect(() => {
//     getProductData();
//   }, [productSearch]);

//   console.log(enquiryDetails);
//   console.log(productData);

//   return (
//     <div className="container">
//       <br></br>

//       <Form>
//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Enquiry No.</Form.Label>
//               <Form.Control disabled type="text" name="enquirydate" value={enquiryDetails.enquiryno} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Enquiry Date</Form.Label>
//               <Form.Control disabled type="date" name="enquirydate" value={enquiryDetails.enquirydate} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Customer Name</Form.Label>
//               <Select
//                 isDisabled
//                 value={customerNameValue}
//                 options={customerOptions}
//                 onChange={(event) => handleFormChange(event, "customer")}
//                 onInputChange={(event) => {
//                   setCustomerSearch(event);
//                 }}
//               />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Contact Person</Form.Label>
//               <Form.Control value={enquiryDetails.contactperson} disabled />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Contact Number</Form.Label>
//               <Form.Control value={enquiryDetails.contactno} disabled />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Email</Form.Label>
//               <Form.Control value={enquiryDetails.email} disabled />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Customer Address</Form.Label>
//               <Select isDisabled value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
//             </Form.Group>
//           </Col>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Customer Material Code</Form.Label>
//               <Form.Control disabled type="text" name="customermaterialcode" value={enquiryDetails.customermaterialcode} onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Currency</Form.Label>
//               <Form.Select disabled onChange={(e) => handleFormChange(e, "enquirycurrency")} name="enquirycurrency" value={enquiryDetails.enquirycurrency}>
//                 <option>Select Currency</option>
//                 <option value="$ (USD)">$ (USD)</option>
//                 <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
//                 <option value="GBP (Pounds)">GBP (Pounds)</option>
//                 <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
//                 <option value="₹ (INR)">₹ (INR)</option>
//               </Form.Select>
//             </Form.Group>
//           </Col>

//           <Col md="6">
//             <Form.Group>
//               <Form.Label>Status</Form.Label>
//               <Form.Control type="text" name="status" value={enquiryDetails.status} disabled onChange={handleFormChange} />
//             </Form.Group>
//           </Col>
//         </Row>

//         <br></br>
//         <hr></hr>

//         <br></br>
//         <div className="table-responsive">
//           <Table>
//             <thead>
//               <tr>
//                 <th style={{ width: "150px" }}>Product Description</th>
//                 <th>Pump Serial No.</th>
//                 <th>Model No.</th>
//                 <th>Tag No.</th>
//                 <th>MOC</th>
//                 <th>Part No.</th>
//                 <th>unit of measurement</th>
//                 <th>Currency</th>
//                 <th>Quantity</th>
//               </tr>
//             </thead>
//             <tbody>
//               {enquiryDetails.enquiryItems.map((item, index) => (
//                 <tr key={index}>
//                   <td>
//                     {item.description}
//                     <Form.Control
//                       disabled
//                       as="textarea"
//                       rows={2}
//                       className="remarkss"
//                       type="text"
//                       value={item.productdescription}
//                       placeholder="Enter item remarks"
//                       contentEditable="true"
//                       onChange={(e) => {
//                         let rows = enquiryDetails.enquiryItems;
//                         rows[index].productremarks = e.target.value;
//                         setEnquiryDetails({
//                           ...enquiryDetails,
//                           enquiryItems: rows,
//                         });
//                       }}
//                     />
//                   </td>
//                   <td>{item.serialnumber}</td>
//                   <td>{item.modelnumber}</td>
//                   <td>{item.tagnumber}</td>
//                   <td>{item.moc}</td>
//                   <td>{item.partno}</td>
//                   <td>
//                     <Form.Select
//                       className="uom"
//                       disabled
//                       value={item.uom ? item.uom.toLowerCase() : ""}
//                       onChange={(event) => {
//                         // Update the unit of measurement in the respective item
//                         const newItems = [...enquiryDetails.enquiryItems];
//                         newItems[index].uom = event.target.value; // Store the selected value as is
//                         setEnquiryDetails({ ...enquiryDetails, enquiryItems: newItems });
//                       }}
//                     >
//                       <option value="">Select UOM</option>
//                       <option value="bot (bottle)">Bot (Bottle)</option>
//                       <option value="ctn (carton)">Ctn (Carton)</option>
//                       <option value="days">Days</option>
//                       <option value="ft (feet)">Ft (FEET)</option>
//                       <option value="hrs (hour)">Hrs (Hour)</option>
//                       <option value="kg (kilogram)">Kg (Kilogram)</option>
//                       <option value="kgs.">Kgs.</option>
//                       <option value="ltr (littre)">Ltr (Littre)</option>
//                       <option value="mtr">Mtr</option>
//                       <option value="nos (number)">Nos (Number)</option>
//                       <option value="pil (pail)">Pil (Pail)</option>
//                       <option value="pkt (packet)">Pkt (Packet)</option>
//                       <option value="set (sets)">Set (Sets)</option>
//                       <option value="pcs (pcs)">Pcs (Pcs)</option>
//                     </Form.Select>
//                   </td>
//                   <td>{item.currency}</td>
//                   <td>
//                     <Form.Control disabled className="quantity" min="0" value={item.quantity} type="number" onChange={(event) => handleQuantityChange(event, index)} />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default ViewAraiMfgSalesEnquiry;




import axios from "axios";
import React, { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Badge, Container, Button } from "react-bootstrap";
import { useNavigate, useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { BASE_URL } from "../../../../services/Api";
import { authHeader } from "../../../../services/auth-header";
import { FaArrowLeft } from "react-icons/fa";

const ViewAraiMfgSalesEnquiry = ({ enquiryData }) => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [enquiryDetails, setEnquiryDetails] = useState(null);
  const [customerAddress, setCustomerAddress] = useState(null);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (enquiryData) {
      setEnquiryDetails({
        enquiryno: enquiryData?.enquiryno,
        enquirydate: enquiryData?.enquirydate,
        enquirytype: enquiryData?.enquirytype,
        enquirycategory: enquiryData?.enquirycategory,
        customer: enquiryData?.customer,
        contactperson: enquiryData?.contactperson,
        contactno: enquiryData?.contactno,
        email: enquiryData?.email,
        status: enquiryData?.status,
        customermaterialcode: enquiryData?.customermaterialcode,
        enquirycurrency: enquiryData?.enquirycurrency,
      });

      setCustomerAddress(enquiryData?.customeraddress);

      if (enquiryData?.enquiryItems && enquiryData.enquiryItems.length > 0) {
        setRows(enquiryData.enquiryItems.map(item => ({
          description: item.product?.description || '-',
          productremarks: item.productremarks || "-",
          serialnumber: item.serialnumber || "-",
          modelnumber: item.modelnumber || "-",
          tagnumber: item.tagnumber || "-",
          moc: item.moc || "-",
          partno: item.partno || "-",
          uom: item.uom || "-",
          currency: item.currency || "-",
          quantity: item.quantity || 0,
        })));
      }
      setIsLoading(false);
    }
  }, [enquiryData]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN');
  };

  const getAddressString = (address) => {
    if (!address) return '-';
    return [
      address.customeraddress,
      address.city?.cityname,
      address.state?.statename,
      address.pincode,
      address.country?.countryname
    ].filter(Boolean).join(', ');
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Active': return 'success';
      case 'Draft': return 'secondary';
      case 'Pending': return 'warning';
      case 'Completed': return 'success';
      case 'Cancelled': return 'danger';
      default: return 'info';
    }
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!enquiryDetails) {
    return <div className="alert alert-danger text-center mt-4">Enquiry not found</div>;
  }

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">MANUFACTURING SALES ENQUIRY - VIEW</h5>
            <div>
              <Button variant="secondary" size="sm" onClick={() => navigate(-1)}>
                <FaArrowLeft className="me-1" />
                Back
              </Button>
            </div>
          </div>

          <Row className="g-2">
            <Col md={3}>
              <div className="border-start border-3 border-primary ps-2">
                <small className="text-muted">Enquiry No</small>
                <div className="fw-bold">{enquiryDetails.enquiryno || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-success ps-2">
                <small className="text-muted">Enquiry Date</small>
                <div className="fw-bold">{formatDate(enquiryDetails.enquirydate)}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-warning ps-2">
                <small className="text-muted">Enquiry Type</small>
                <div className="fw-bold">{enquiryDetails.enquirytype || '-'}</div>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-start border-3 border-info ps-2">
                <small className="text-muted">Status</small>
                <div>
                  <Badge bg={getStatusBadge(enquiryDetails.status)} className="px-2 py-1">
                    {enquiryDetails.status || '-'}
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Enquiry Details */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Enquiry Details</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Enquiry Category</small>
              <div className="fw-bold">{enquiryDetails.enquirycategory || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Currency</small>
              <div className="fw-bold">{enquiryDetails.enquirycurrency || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Customer Material Code</small>
              <div className="fw-bold">{enquiryDetails.customermaterialcode || '-'}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Customer Information */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Customer Information</h6>
        </div>
        <div className="p-3">
          <Row className="g-3">
            <Col md={4}>
              <small className="text-muted">Company Name</small>
              <div className="fw-bold">{enquiryDetails.customer?.companyname || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Contact Person</small>
              <div className="fw-bold">{enquiryDetails.contactperson || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">GST No</small>
              <div className="fw-bold">{enquiryDetails.customer?.gstno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Phone</small>
              <div className="fw-bold">{enquiryDetails.contactno || '-'}</div>
            </Col>
            <Col md={4}>
              <small className="text-muted">Email</small>
              <div className="fw-bold">{enquiryDetails.email || '-'}</div>
            </Col>
            <Col md={12}>
              <small className="text-muted">Address</small>
              <div className="fw-bold">{getAddressString(customerAddress)}</div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Enquiry Items */}
      <div className="shadow-sm border rounded bg-white mb-3">
        <div className="bg-light py-2 px-3 border-bottom">
          <h6 className="mb-0 fw-bold">Enquiry Items</h6>
        </div>
        <div className="p-0">
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center fw-bold py-2">#</th>
                  <th className="fw-bold py-2">Description</th>
                  <th className="fw-bold py-2">Part No</th>
                  <th className="fw-bold py-2">Serial No</th>
                  <th className="fw-bold py-2">Model No</th>
                  <th className="fw-bold py-2">Tag No</th>
                  <th className="fw-bold py-2">MOC</th>
                  <th className="fw-bold py-2 text-center">UOM</th>
                  <th className="fw-bold py-2">Currency</th>
                  <th className="fw-bold py-2 text-center">Qty</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{row.description || '-'}</div>
                      {row.productremarks && row.productremarks !== '-' && (
                        <div className="text-muted small mt-1">
                          <small><strong>Remarks:</strong> {row.productremarks}</small>
                        </div>
                      )}
                    </td>
                    <td>{row.partno || '-'}</td>
                    <td>{row.serialnumber || '-'}</td>
                    <td>{row.modelnumber || '-'}</td>
                    <td>{row.tagnumber || '-'}</td>
                    <td>{row.moc || '-'}</td>
                    <td className="text-center">{row.uom || '-'}</td>
                    <td>{row.currency || '-'}</td>
                    <td className="text-center">{row.quantity || '0'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="text-center mt-3 pt-2 border-top">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="me-1" />
          Back to List
        </Button>
      </div>
    </Container>
  );
};

export default ViewAraiMfgSalesEnquiry;